import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EWaitlistStatus;
(function (EWaitlistStatus) {
  EWaitlistStatus["Waiting"] = "waiting";
  EWaitlistStatus["InFlight"] = "in-flight";
  EWaitlistStatus["Offered"] = "offered";
  EWaitlistStatus["Confirming"] = "confirming";
  EWaitlistStatus["Accepted"] = "accepted";
  EWaitlistStatus["Pending"] = "pending";
  EWaitlistStatus["Declined"] = "declined";
  EWaitlistStatus["Expired"] = "expired";
  EWaitlistStatus["Incomplete"] = "incomplete";
})(EWaitlistStatus || (EWaitlistStatus = {}));
export let EWaitlistBookedBy;
(function (EWaitlistBookedBy) {
  EWaitlistBookedBy["Provider"] = "provider";
  EWaitlistBookedBy["Department"] = "department";
  EWaitlistBookedBy["Patient"] = "patient";
  EWaitlistBookedBy["Auto"] = "auto";
  EWaitlistBookedBy["Integrator"] = "integrator";
})(EWaitlistBookedBy || (EWaitlistBookedBy = {}));
export let EWaitlistPreferredTime;
(function (EWaitlistPreferredTime) {
  EWaitlistPreferredTime["BeforeLunch"] = "before-lunch";
  EWaitlistPreferredTime["AfterLunch"] = "after-lunch";
  EWaitlistPreferredTime["Anytime"] = "anytime";
})(EWaitlistPreferredTime || (EWaitlistPreferredTime = {}));
export let EWaitlistPreferedDays;
(function (EWaitlistPreferedDays) {
  EWaitlistPreferedDays[EWaitlistPreferedDays["Sunday"] = 0] = "Sunday";
  EWaitlistPreferedDays[EWaitlistPreferedDays["Monday"] = 1] = "Monday";
  EWaitlistPreferedDays[EWaitlistPreferedDays["Tuesday"] = 2] = "Tuesday";
  EWaitlistPreferedDays[EWaitlistPreferedDays["Wednesday"] = 3] = "Wednesday";
  EWaitlistPreferedDays[EWaitlistPreferedDays["Thursday"] = 4] = "Thursday";
  EWaitlistPreferedDays[EWaitlistPreferedDays["Friday"] = 5] = "Friday";
  EWaitlistPreferedDays[EWaitlistPreferedDays["Saturday"] = 6] = "Saturday";
})(EWaitlistPreferedDays || (EWaitlistPreferedDays = {}));
export let EWaitlistSource;
(function (EWaitlistSource) {
  EWaitlistSource["Upload"] = "upload";
  EWaitlistSource["Ui"] = "ui";
  EWaitlistSource["Integrator"] = "integrator";
  EWaitlistSource["AppointmentBooking"] = "appointment-booking";
})(EWaitlistSource || (EWaitlistSource = {}));
export const fieldsWaitlist = _extends({}, fieldsIBaseModel, {
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType,
    array: true
  },
  approvedBy: {
    type: 'ID',
    ref: EModel.User
  },
  bookedBy: {
    type: 'Option',
    values: EWaitlistBookedBy
  },
  createdFromAppointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  declinedBy: {
    type: 'ID',
    ref: EModel.User
  },
  declinedOffer: {
    type: 'ID',
    ref: EModel.Offer
  },
  department: {
    type: 'Text'
  },
  duration: {
    type: 'Number'
  },
  expireAt: {
    type: 'Date'
  },
  externalId: {
    type: 'Object'
  },
  externalRawSource: {
    type: 'Object'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  futureAppointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  futureAppointmentBestMatch: {
    type: 'Boolean'
  },
  holdUntil: {
    type: 'Date'
  },
  inflightOffer: {
    type: 'ID',
    ref: EModel.Offer
  },
  notes: {
    type: 'Text'
  },
  offer: {
    type: 'ID',
    ref: EModel.Offer
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  preferredDays: {
    type: 'Option',
    values: EWaitlistPreferedDays,
    array: true
  },
  preferredTime: {
    type: 'Option',
    values: EWaitlistPreferredTime
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider,
    array: true
  },
  source: {
    type: 'Option',
    values: EWaitlistSource
  },
  stats: {
    type: 'Object'
  },
  status: {
    type: 'Option',
    values: EWaitlistStatus
  },
  tags: {
    type: 'Text',
    array: true
  }
});